import React, { useState, useContext } from 'react'
import setGraphQLErrors from '@orionx-dev/orionsoft-parts/lib/helpers/setGraphQLErrors'
import { Form, Field } from 'simple-react-form'
import styles from './styles.css'
import Select from 'App/components/fields/Select'
import Button from '@orionx-dev/orionsoft-parts/lib/components/Button'
import { KycContext } from 'App/KYC/Layout'
import { useNavigate } from 'react-router-dom'
import translate from 'App/i18n/translate'
import availableCountries from 'App/helpers/countries/available'
import { documentOptions } from '../utils/documentOptions'

const RequiredInformation = () => {
  const navigate = useNavigate()
  const { kyc, setKyc, updateKyc } = useContext(KycContext)
  const [form, setForm] = useState({
    countryCode: '',
    documentType: '',
  })

  const getPath = complianceType => {
    if (complianceType === 'TOC') {
      return 'toc/front'
    } else if (complianceType.includes('Manual')) {
      return 'manual-verification'
    } else {
      return 'toc/front'
    }
  }

  const save = async () => {
    try {
      setKyc({
        ...kyc,
        documentType: form.documentType.value,
        countryCode: form.countryCode.value,
      })
      await updateKyc(kyc.id, {
        documentType: form.documentType.value,
        countryCode: form.countryCode.value,
      })

      navigate(`../${getPath(kyc.complianceType)}`)
    } catch (error) {
      console.error(error)
      setGraphQLErrors(this, error)
    }
  }

  const formOnChange = val => {
    setForm(prevForm => ({
      ...prevForm,
      ...val,
    }))
  }

  return (
    <div className={styles.container}>
      <Form className={styles.form} state={form} onChange={formOnChange}>
        <div>
          <div className={styles.sectionTitle}>
            <h1>Ingresa tus datos personales</h1>
            <span>
              Toda tu información es confidencial y sólo se te pedirá esta vez para verificar y
              proteger tu identidad.
            </span>
          </div>

          <div className={styles.personalForm}>
            <div className={styles.inputWrapper}>
              <label className="mt-3 mb-1 inline-block">{translate('auth.pages.country')}</label>
              <Field
                fieldName="countryCode"
                type={Select}
                placeholder={translate('auth.pages.country')}
                style={{ backgroundColor: '#fff' }}
                className="tds-orionx-override-dropdown"
                options={availableCountries}
              />
            </div>

            <div className={styles.inputWrapper}>
              <label className="tds-orionx-input__label">Tipo de Documento</label>
              <Field
                fieldName="documentType"
                type={Select}
                placeholder="Elige una opción"
                options={documentOptions[form.countryCode.value]}
                className="tds-orionx-override-dropdown"
              />
            </div>
          </div>
          <div className={styles.submit}>
            <Button onClick={save} className={styles.buttonPrimary}>
              Siguiente
            </Button>
          </div>
        </div>
      </Form>
    </div>
  )
}

export default RequiredInformation
